import ElevateSpinner from './ElevateSpinner';

const FullPageSpinner = () => <ElevateSpinner variant="full-page" />;

export default FullPageSpinner;
